window.addEventListener('load', initializeCustom);

function initializeCustom() {

    $(".product-gallery--navigation").hide();

    var galleryFig = $("figure.product-gallery--image");
    $(".jace_spin_bg").appendTo(galleryFig);

    resizeSpin();
    $(window).resize(resizeSpin);

    var fn = getQueryVariable("custom-art") || getQueryVariable("custom_art");
    var fn_url = "https://jace.design/images/bottle/custom/" + fn;
    $("#print-url").attr("value", "&custom-art=" + fn);
    $("#print-filename").attr("value", fn);
    console.log(fn);

    checkImageGood(fn_url, function () {
        $(".jace_spin_strip div").css("background-image", "url('" + fn_url + "')");
    })

    function checkImageGood(imageSrc, callback) {
        var img = new Image();
        img.onload = callback;
        //img.onerror = bad;
        img.src = imageSrc;
    }

    function resizeSpin() {
        $(".jace_spin_bg").each(function (i, v) {
            var sf = $(this).parent().width() / 2000;
            $(this).css("transform", "scale(" + sf + ")");
        });
    }

    function getQueryVariable(variable) {
        var query = window.location.search.substring(1);
        var vars = query.split("&");
        for (var i = 0; i < vars.length; i++) {
            var pair = vars[i].split("=");
            if (pair[0] == variable) {
                return pair[1];
            }
        }
        return false;
    }

    $(".jace_spin_bg").on("click", function () {
        var elem = $(this).children().first().children().first().children().first();
        if (!elem.css("animation-play-state") || elem.css("animation-play-state") == "paused") elem.css("animation-play-state", "running");
        else elem.css("animation-play-state", "paused");
    });

}
